import {AfterViewInit, Component, Input} from '@angular/core';

// rich editor
declare var Jodit;

@Component({
  selector: 'app-text-editor',
  template: `
    <div id="targetEditor">
    </div>
  `,
  styleUrls: ['./text-editor.component.css']
})
export class TextEditorComponent implements AfterViewInit {

  // editor
  editor: any;

  // configurazione di input
  // vedi https://xdsoft.net/jodit/play.html
  // https://xdsoft.net/jodit/play.html?disablePlugins=image%2Cmedia%2Cvideo%2Cfile%2Cresizer%2Cresize-handler%2Cresize-cells%2Cfullsize&currentTab=Plugins
  @Input() config = {
    language: "it",
    "disablePlugins": "image,media,video,file,resizer,resize-handler,resize-cells,fullsize"
  };

  constructor() {
  }

  show() {
    if (!this.editor) {
      this.editor = new Jodit('#targetEditor', this.config);
    }
  }

  ngAfterViewInit(): void {
    this.show()
  }

  setText(text: string) {
    this.editor.value = text;
  }

  getText() {
    return this.editor.value;
  }

  setReadOnly() {
    this.editor.setReadOnly(true);
  }
  setEditable() {
    this.editor.setReadOnly(false);
  }

  print() {
    this.editor.execCommand('print');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/text-editor/text-editor.component.ts